export default {
    env: process.env.MIX_APP_ENV,
    appName: process.env.MIX_APP_NAME,
    gaId: process.env.MIX_GA_ID,
    postsPerPage: process.env.MIX_POSTS_PER_PAGE,
    shopPacksPerPage: process.env.MIX_SHOP_PACKS_PER_PAGE,
    email: process.env.MIX_APP_EMAIL,
    totalRequiredDonations: process.env.MIX_TOTAL_REQUIRED_DONATIONS,
    features: {
        showTotalDonations: process.env.MIX_SHOW_TOTAL_DONATIONS
    },
    default: {
        shopCategory: 'popular',
    },
}
